var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"content"}},[_c('div',{staticClass:"search-bar"},[_c('quote-search',{attrs:{"preferenceVisible":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }